const THREE = require('three')
import {loadingManager, load, registerSize} from '../loader'
import {maxAnisotropy} from '../renderer'
import scene from '../scene'
import {config as gameConfig} from '../config'
let skyboxTextureUrl = require('assets/models/sky/sky.jpg')
registerSize(skyboxTextureUrl, 45812)


const textureLoader = new THREE.TextureLoader(loadingManager)

let geometry = new THREE.SphereGeometry(2000, 64, 64)
let material = new THREE.MeshBasicMaterial({
  side: THREE.BackSide,
  fog: false
})

export let mesh = new THREE.Mesh(geometry, material)
export default mesh
mesh.scale.set(2, 1, 2)
mesh.scale.multiplyScalar(gameConfig.worldScale)

scene.add(mesh)

load(skyboxTextureUrl, textureLoader, (textureResults)=> {
  let texture = textureResults[0]
  material.map = texture
  material.needsUpdate = true
  texture.anisotropy = maxAnisotropy
  texture.wrapS = texture.wrapT = THREE.RepeatWrapping
})





// WEBPACK FOOTER //
// ./src/components/game/objects/sky.js